// src/utils/api.js

import service from './axios' // 引入 axios 实例

export const msg_tips = {
  'user.password.not.match': 'Username or password error!',
}

// 格式化日期函数
export function formatDate(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return dateString
  
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
export function formatDate1(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return dateString

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}${month}${day} ${hours}:${minutes}:${seconds}`
}

export const getDisplayName = (po, h) => {
  // if (wo.amount)
  let wo = po.withdrawOrder
  let res = wo.receiverName
  if (!h) return res
  if ((wo.payType === 'stcpay' || wo.payType === 'barq' || wo.payType === 'urpay') && po.payAmount < 500) {
    let words = res.split(' ')
    let tmp = ''
    for (let word of words) {
      tmp += word.charAt(0) + '**** '
    }
    res = tmp
  }
  return res
}

export const getTips = (key) => {
  key = key + ''
  if (key.indexOf('Error:') > -1)
    key = key.replace('Error:', '')
  return msg_tips[key] || key
}

export const getCurrency = () => {
  return localStorage.getItem('currency') || ''
}
export const pay_order_state_map = {
  'p_w': 'Wait',
  'p_wt': 'Pay Timeout wait',
  'p_t': 'Pay Timeout',
  'p_d': 'Review',
  'p_s': 'Succeed',
  'p_f': 'Failed',
  'p_e': 'Error',
  'p_c': 'Correct',
}
// 获取用户信息
export const getUserInfo = () => {
  return service({
    url: '/getInfo',
    method: 'get',
  })
}

export const getProfile = () => {
  return service({
    url: '/user/profile',
    method: 'get',
  })
}

/** 收款备注隐藏 Account No 关键词（sys_config，仅 mz-app-ui 使用） */
export const getReceiverAccountRemarkHideKeywords = () => {
  return service({
    url: '/bus/user/receiver-account-remark/hide-keywords',
    method: 'get',
  })
}

/** 查询自动接单开关 */
export const getAutoReceiveSetting = () => {
  return service({
    url: '/bus/user/auto-receive',
    method: 'get',
  })
}

/** 更新自动接单开关 */
export const updateAutoReceiveSetting = (data) => {
  return service({
    url: '/bus/user/auto-receive',
    method: 'put',
    data,
  })
}
// 提款操作
export const withdrawals = (data) => {
  return service.post('/withdrawals', data)
}

// 登出操作
export const logout = () => {
  return service.post('/logout')
}
// 登录
export const login = (data) => {
  return service.post('/login', data)
}
// receivlist
export const receivlist = (data) => {
  return service({
    url: '/bus/user/order/list',
    method: 'get',
    params: data
  })
  // return service.get('/bus/user/order/list', data);
}
// receive
export const receive = (data) => {
  // return service({
  //   url: '/bus/user/order/receive',
  //   method: 'post',
  //   params: data
  // })
  return service.post('/bus/user/order/receive', data)
}

// teams
export const teams = () => {
  return service.get('/bus/user/teams')
}
// 申请提现
export const applyWithdraw = (data) => {
  return service.post('/bus/user/withdrawV2', data)
}

export function listPay_order (data) {
  return service({
    url: '/bus/user/porder/list',
    method: 'get',
    params: data
  })
}

// 上传图片
export function uploads (data) {
  return service.post('/common/upload', data)
}

export function updatePay_orderConfirm (data) {
  return service({
    url: '/bus/user/porder/confirm',
    method: 'put',
    data: data
  })
  // return service.post('/bus/user/porder/confirm/v2', data)
}

export function updatePay_orderInvalid (data) {
  return service({
    url: '/bus/user/porder/confirm/invalid',
    method: 'put',
    data: data
  })
  // return service.post('/bus/user/porder/confirm/v2', data)
}

export function updatePay_orderCancel (data) {
  return service({
    url: '/bus/user/porder/cancel',
    method: 'put',
    data: data
  })
  // return service.post('/bus/user/porder/confirm/v2', data)
}

export function updatePay_orderConfirmV2 (data) {
  return service.post('/bus/user/porder/confirm/v2', data)
}

// 实名认证
export function updatePay_orderRealname (data) {
  return service.post('/user/profile/update/realinfo', data)
}

// 提现方式
export function getWithdrawType () {
  return service({
    url: '/system/dict/data/type/withdraw_order_account_type',
    method: 'get',
  })
}

// 提款记录
export function getWithdrawRecords (data) {
  return service({
    url: '/bus/UserPropertyLog/list',
    method: 'get',
    params: data
  })
}

// 统计
export function getStatistics (data) {
  return service({
    url: '/stat/stat/list',
    method: 'get',
    params: data
  })
}

/** 修改登录密码（与 client `PUT /user/profile/updatePwd` + JSON Body 对齐） */
export function updatePassword (oldPassword, newPassword) {
  return service({
    url: '/user/profile/updatePwd',
    method: 'put',
    data: { oldPassword, newPassword },
  })
}

export function resetPwd (oldPassword, newPassword) {
  return updatePassword(oldPassword, newPassword)
}

export { PAY_TYPE_LABELS as pay_type_map } from './payoutDisplay'

// ========== 联系人任务相关 API ==========

// 获取可接任务列表
export function getAvailableContactTasks (data) {
  return service({
    url: '/client/contact-task/available',
    method: 'get',
    params: data
  })
}

// 接单
export function receiveContactTask (taskId) {
  return service.post(`/client/contact-task/receive/${taskId}`)
}

// 获取我的联系人任务订单列表
export function listContactTaskOrders (data) {
  return service({
    url: '/client/contact-task-order/list',
    method: 'get',
    params: data
  })
}

// 获取联系人任务订单详情
export function getContactTaskOrder (id) {
  return service({
    url: `/client/contact-task-order/${id}`,
    method: 'get'
  })
}

// 上传联系人任务凭证
export function uploadContactTaskEvidence (id, file, desc) {
  const formData = new FormData()
  formData.append('file', file)
  if (desc) {
    formData.append('desc', desc)
  }
  return service.post(`/client/contact-task-order/${id}/evidence`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取订单话术（已替换占位符）
export function getContactTaskOrderSpeech (id) {
  return service({
    url: `/client/contact-task-order/${id}/speech`,
    method: 'get'
  })
}

// 获取订单处理进度
export function getContactTaskOrderProgress (id) {
  return service({
    url: `/client/contact-task-order/${id}/progress`,
    method: 'get'
  })
}

// 标记账号处理结果
export function markContactTaskAccountResult (orderId, accountIndex, result, remark) {
  return service({
    url: `/client/contact-task-order/${orderId}/account/${accountIndex}/result`,
    method: 'post',
    data: {
      result,
      remark
    }
  })
}
